import { EnhancedMedia } from 'components/EnhancedMedia/EnhancedMedia';

export function playEnhancedMedia(media: EnhancedMedia | null) {
  if (!media) return;
  media.play();
}

export function pauseEnhancedMedia(media: EnhancedMedia | null) {
  if (!media) return;
  media.pause();
  media.reloadMedia(); // force-reload media so background image gets shown again
}

export function areAllSlidesNotVisible(elements?: HTMLCollection, offsetEl?: HTMLElement | null): boolean {
  if (!elements || elements.length === 0) return false;

  const { left = 0 } = elements.item(0)?.getBoundingClientRect() ?? {};
  const { right = 0 } = elements.item(elements.length - 1)?.getBoundingClientRect() ?? {};
  const { left: offset = 0 } = offsetEl?.getBoundingClientRect() ?? {};

  return right - left > window.innerWidth - offset;
}
